import { useCallback, useEffect, useState } from 'react';
import { api } from '../../lib/api';

const filtrosVacios = {
  desde: '',
  hasta: '',
  usuario_id: '',
  medio_pago_id: '',
};

export default function useRestauranteHistorial() {
  const [cuentas, setCuentas] = useState([]);
  const [cargando, setCargando] = useState(false);
  const [error, setError] = useState('');
  const [filtros, setFiltros] = useState(filtrosVacios);

  const cargar = useCallback(async (filtrosActuales = {}) => {
    try {
      setCargando(true);
      setError('');

      const params = {};

      if (filtrosActuales.desde) {
        params.desde = filtrosActuales.desde;
      }

      if (filtrosActuales.hasta) {
        params.hasta = filtrosActuales.hasta;
      }

      if (filtrosActuales.usuario_id) {
        params.usuario_id = filtrosActuales.usuario_id;
      }

      if (filtrosActuales.medio_pago_id) {
        params.medio_pago_id =
          filtrosActuales.medio_pago_id;
      }

      const response = await api.get(
        '/restaurante/cuentas/historial',
        { params }
      );

      setCuentas(
        Array.isArray(response.data) ? response.data : []
      );
    } catch (err) {
      console.error(
        'Error cargando historial Restaurante:',
        err
      );

      setCuentas([]);
      setError(
        err?.response?.data?.error ||
          'No se pudo cargar el historial del Restaurante.'
      );
    } finally {
      setCargando(false);
    }
  }, []);

  const aplicarFiltros = () => {
    cargar(filtros);
  };

  const limpiarFiltros = () => {
    const vacios = {
      ...filtrosVacios,
    };

    setFiltros(vacios);
    cargar(vacios);
  };

  useEffect(() => {
    cargar({});
  }, [cargar]);

  return {
    cuentas,
    cargando,
    error,
    filtros,
    setFiltros,
    cargar,
    aplicarFiltros,
    limpiarFiltros,
  };
}
